/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BackendConfiguration } from './BackendConfiguration';
import {
    BackendConfigurationFromJSON,
    BackendConfigurationFromJSONTyped,
    BackendConfigurationToJSON,
} from './BackendConfiguration';
import type { TenantModules } from './TenantModules';
import {
    TenantModulesFromJSON,
    TenantModulesFromJSONTyped,
    TenantModulesToJSON,
} from './TenantModules';
import type { TenantSocialLinks } from './TenantSocialLinks';
import {
    TenantSocialLinksFromJSON,
    TenantSocialLinksFromJSONTyped,
    TenantSocialLinksToJSON,
} from './TenantSocialLinks';
import type { TenantTheme } from './TenantTheme';
import {
    TenantThemeFromJSON,
    TenantThemeFromJSONTyped,
    TenantThemeToJSON,
} from './TenantTheme';

/**
 * 
 * @export
 * @interface Tenant
 */
export interface Tenant {
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    name: string;
    /**
     * 
     * @type {Array<BackendConfiguration>}
     * @memberof Tenant
     */
    configurations?: Array<BackendConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    company_website: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    name_short: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    default_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    support_email: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    info_email: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    dev_email?: string;
    /**
     * Email addresses that receive the daily/weekly statistics digest and the monthly management ratings report. When absent or empty, no statistics emails are compiled or sent for this tenant.
     * @type {Array<string>}
     * @memberof Tenant
     */
    stats_email_recipients?: Array<string>;
    /**
     * Admin record the AI assistant posts as (signed chat messages, document annotations). When absent, falls back to matching an admin named exactly "Carey (AI Assistant)".
     * @type {string}
     * @memberof Tenant
     */
    assistant_admin_id?: string;
    /**
     * IANA timezone the tenant operates in (e.g. America/Toronto). Drives calendar formatting, slot/shift math, scheduled sends and tenant-local cron fires. Tenant-self-serve via tenant-options. ALWAYS falls back to America/Toronto when absent — no code may read this field directly; use calendarUtils.getTargetTimezone().
     * @type {string}
     * @memberof Tenant
     */
    timezone?: string;
    /**
     * Patient-facing term for the tenant's admin/support staff (e.g. Concierge). Tenant-self-serve via tenant-options; falls back to "Staff Member" when absent — resolve via tenantFeatures.staffTitle(), never read directly.
     * @type {string}
     * @memberof Tenant
     */
    staff_title?: string;
    /**
     * Whether patients can request prescription refills themselves. Tenant-self-serve via tenant-options. ABSENT = ON (unlike modules, which default off) — every tenant had refill requests before this option existed, so absence must not dark them. Resolve via tenantFeatures.refillRequests.enabled(), which also ANDs in continuityOfCare; never read this field directly.
     * @type {boolean}
     * @memberof Tenant
     */
    refill_requests?: boolean;
    /**
     * Country the tenant operates in (e.g. Canada). Ops-configured; drives jurisdiction copy such as the subscription agreement governing-law clause. Falls back to Canada when absent.
     * @type {string}
     * @memberof Tenant
     */
    country?: string;
    /**
     * Province/state the tenant operates in (e.g. Ontario). Ops-configured; drives jurisdiction copy (governing law) and future region-specific behavior. Falls back to Ontario when absent.
     * @type {string}
     * @memberof Tenant
     */
    province?: string;
    /**
     * 
     * @type {TenantSocialLinks}
     * @memberof Tenant
     */
    social_links?: TenantSocialLinks;
    /**
     * 
     * @type {TenantTheme}
     * @memberof Tenant
     */
    theme?: TenantTheme;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    app_subdomain: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    portal_subdomain: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    default_clinic?: string;
    /**
     * Tenant-wide default cancellation/credit window (hours). Applies when a concern sets no refund_window_hours override. Clamped 0..168. If unset, appointments with no concern override are NOT eligible for credit.
     * @type {number}
     * @memberof Tenant
     */
    default_refund_window_hours?: number;
    /**
     * 
     * @type {TenantModules}
     * @memberof Tenant
     */
    modules?: TenantModules;
}

/**
 * Check if a given object implements the Tenant interface.
 */
export function instanceOfTenant(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "company_website" in value;
    isInstance = isInstance && "name_short" in value;
    isInstance = isInstance && "support_email" in value;
    isInstance = isInstance && "info_email" in value;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "app_subdomain" in value;
    isInstance = isInstance && "portal_subdomain" in value;

    return isInstance;
}

export function TenantFromJSON(json: any): Tenant {
    return TenantFromJSONTyped(json, false);
}

export function TenantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tenant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'configurations': !exists(json, 'configurations') ? undefined : ((json['configurations'] as Array<any>).map(BackendConfigurationFromJSON)),
        'company_website': json['company_website'],
        'name_short': json['name_short'],
        'default_phone': !exists(json, 'default_phone') ? undefined : json['default_phone'],
        'support_email': json['support_email'],
        'info_email': json['info_email'],
        'dev_email': !exists(json, 'dev_email') ? undefined : json['dev_email'],
        'stats_email_recipients': !exists(json, 'stats_email_recipients') ? undefined : json['stats_email_recipients'],
        'assistant_admin_id': !exists(json, 'assistant_admin_id') ? undefined : json['assistant_admin_id'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'staff_title': !exists(json, 'staff_title') ? undefined : json['staff_title'],
        'refill_requests': !exists(json, 'refill_requests') ? undefined : json['refill_requests'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'province': !exists(json, 'province') ? undefined : json['province'],
        'social_links': !exists(json, 'social_links') ? undefined : TenantSocialLinksFromJSON(json['social_links']),
        'theme': !exists(json, 'theme') ? undefined : TenantThemeFromJSON(json['theme']),
        'domain': json['domain'],
        'app_subdomain': json['app_subdomain'],
        'portal_subdomain': json['portal_subdomain'],
        'default_clinic': !exists(json, 'default_clinic') ? undefined : json['default_clinic'],
        'default_refund_window_hours': !exists(json, 'default_refund_window_hours') ? undefined : json['default_refund_window_hours'],
        'modules': !exists(json, 'modules') ? undefined : TenantModulesFromJSON(json['modules']),
    };
}

export function TenantToJSON(value?: Tenant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'configurations': value.configurations === undefined ? undefined : ((value.configurations as Array<any>).map(BackendConfigurationToJSON)),
        'company_website': value.company_website,
        'name_short': value.name_short,
        'default_phone': value.default_phone,
        'support_email': value.support_email,
        'info_email': value.info_email,
        'dev_email': value.dev_email,
        'stats_email_recipients': value.stats_email_recipients,
        'assistant_admin_id': value.assistant_admin_id,
        'timezone': value.timezone,
        'staff_title': value.staff_title,
        'refill_requests': value.refill_requests,
        'country': value.country,
        'province': value.province,
        'social_links': TenantSocialLinksToJSON(value.social_links),
        'theme': TenantThemeToJSON(value.theme),
        'domain': value.domain,
        'app_subdomain': value.app_subdomain,
        'portal_subdomain': value.portal_subdomain,
        'default_clinic': value.default_clinic,
        'default_refund_window_hours': value.default_refund_window_hours,
        'modules': TenantModulesToJSON(value.modules),
    };
}

